import { BaseSetupStepComponent } from '../base-setup-step-component';
import { BroadcastingSoftware } from '../../../../ng-services/livestreams/BroadcastingSoftware';

export class LivestreamSetupBroadcastingSoftwareComponent extends BaseSetupStepComponent {
    onSelect?: ({ name }: { name: string }) => any;
    selected!: BroadcastingSoftware;

    setActive(name: string) {
        this.onSelect && this.onSelect({ name });
    }

    activeClass(name: string) {
        return name === this.selected ? 'active' : '';
    }

    onSave() {
        this.emitClose();
    }

    get isValid() {
        return Boolean(this.selected);
    }

    get nameText() {
        return 'Broadcasting Software';
    }

    get headingText() {
        switch (this.selected) {
            case BroadcastingSoftware.youtube:
                return 'YouTube';
            case BroadcastingSoftware.tradersyard:
                return 'TradersYard Live';
        }
    }

    get descriptionText() {
        switch (this.selected) {
            case BroadcastingSoftware.youtube:
                return 'We will open YouTube Live studio where you can start your live stream';
            case BroadcastingSoftware.tradersyard:
                return 'We will open a new web-meeting window where you can start your live stream';
        }
    }
}

angular.module('tradersyard').component('tyLivestreamSetupBroadcastingSoftwareComponent', {
    // language=HTML
    template: `
        <ty-livestream-wizard-section open="$ctrl.open" on-open-changed="$ctrl.onOpenChanged(open)">
            <name>{{$ctrl.nameText}}</name>
            <heading>{{$ctrl.headingText}}</heading>
            <description>{{$ctrl.descriptionText}}</description>
            <button-text>
                <span ng-if="!$ctrl.isValid">setup</span>
                <i class="fa fa-check-circle" ng-if="$ctrl.isValid"></i>
            </button-text>

            <wizard-body>
                <div ng-click="$ctrl.setActive('tradersyard_live')"
                     ng-class="$ctrl.activeClass('tradersyard_live')"
                     class="ty_livestream_setup_broadcasting_software_component__option">
                    <i class="fa fa-broadcast-tower"></i> TradersYard Live
                </div>
                <div
                    ng-click="$ctrl.setActive('youtube_studio')"
                    ng-class="$ctrl.activeClass('youtube_studio')"
                    class="ty_livestream_setup_broadcasting_software_component__option">
                    <i class="fab fa-youtube"></i> YouTube Studio
                </div>

                <div class="clearfix">
                    <button class="btn btn-default pull-left" ng-click="$ctrl.emitClose()">Cancel</button>
                    <button class="btn btn-primary pull-right" ng-click="$ctrl.onSave()">Save</button>
                </div>
            </wizard-body>
        </ty-livestream-wizard-section>
    `,
    controller: LivestreamSetupBroadcastingSoftwareComponent,
    bindings: {
        ...BaseSetupStepComponent.bindings,
        onSelect: '&',
        selected: '<',
    },
});
